<template lang="pug">
  v-col(cols="12" sm="12" md="6")
    v-card(height="auto" outlined)
      v-overlay(:value="loading" absolute)
        v-progress-circular(indeterminate)
      apexchart(
        v-if="!loading"
        width="100%"
        height="auto"
        type="donut"
        :options="options"
        :series="dataSeries"
      )
</template>

<script>
import searchService from '@/services/API/search';
import { CRUDProjects } from '@/services/API/project';

export default {
  data() {
    return {
      projects: [],
      series: [],
      loading: false,
    };
  },
  computed:{
    options() {
      return {
        chart: {
          width: '100%',
          type: 'pie',
        },
        labels:this.projects.map(({ name }) => name),
        dataLabels: {
          enabled: true,
          offsetX: 30,
        },

        plotOptions:{
          pie: {
            startAngle: 0,
            expandOnClick: true,
            offsetX: 0,
            offsetY: 0,
            customScale: 1,
            dataLabels: {
              offset: 0,
              minAngleToShowLabel: 10,
            },
            donut: {
              size: '50%',
              background: 'transparent',
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: '22px',
                  fontFamily: 'Helvetica, Arial, sans-serif',
                  fontWeight: 600,
                  color: undefined,
                  offsetY: -10,
                  formatter(val) {
                    return `${val}`;
                  },
                },
                value: {
                  show: true,
                  fontSize: '16px',
                  fontFamily: 'Helvetica, Arial, sans-serif',
                  fontWeight: 400,
                  color: undefined,
                  offsetY: 16,
                  formatter(val) {
                    return `${val}`;
                  },
                },
                total: {
                  show: true,
                  showAlways: true,
                  label: 'Всего',
                  fontSize: '1rem',
                  fontFamily: 'Helvetica, Arial, sans-serif',
                  fontWeight: 600,
                  color: '#373d3f',
                  formatter : () => {
                    const reducer = (accumulator, curr) => accumulator + curr;
                    return this.dataSeries.reduce(reducer, 0);
                  },
                },
              },
            },

          },
        },
      };
    },
    dataSeries() {
      return this.series.map(({ doc_count }) => doc_count);
    },
  },
  async created() {
    const params = {
      'group_by': 'project_id',
    };

    this.loading = true;

    await searchService.clientQuestions(params).then((response) => {
      this.series = response.data.data;
    });

    await CRUDProjects.getAll().then((response) => {
      this.projects = response.data.data;
    });

    this.loading = false;
  },
};
</script>

<style>

</style>
